import { Attribute } from 'src/app/models/attribute';

export class AttributesSelectionResult {
    public selectedAttributes: Attribute[] = [];
}
